var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#081754;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,6.9l-9-2.6c-0.1,0-0.6,0.1-1.1,0.5C4,5.2,3.9,5.5,3.9,5.7c2.2,1.7,4.5,3.4,6.7,5.1 c-1.2,1.3-2.4,2.6-3.6,3.8c-0.7-0.2-1.6-0.4-2.3-0.6c-0.1,0-0.7,0.1-1.2,0.8c-0.2,0.3-0.2,0.8-0.2,0.9c0.5,0.4,1.1,0.9,1.6,1.4 c-0.4,0.6-0.4,1.5,0,2c0.5,0.6,1.5,0.8,2.2,0.1c0.4,0.5,0.8,1.1,1.3,1.6c0.2,0,0.6-0.1,0.9-0.5c0.4-0.4,0.5-1,0.5-1.1 c-0.2-0.8-0.4-1.6-0.6-2.4l3.8-3.4l4.8,6.7c0.1,0,0.6-0.1,1.1-0.5c0.4-0.5,0.4-1.2,0.4-1.2c-0.8-2.9-1.7-5.8-2.4-8.7L20.4,6 c0.4-0.9,0.1-1.8-0.5-2.4c-0.5-0.4-1.4-0.4-2,0C16.5,4.6,15.4,5.8,14.3,6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplane);
export default __webpack_public_path__ + "static/media/airplane.f5e7e54e83ac425602acbcd76009d302.svg";
export { ForwardRef as ReactComponent };